import {
  Button,
  FormControl,
  FormHelperText,
  FormLabel,
  Input,
  InputGroup,
  InputRightElement,
  Stack,
  TabPanel,
  TabPanels,
  Tabs,
  Textarea,
} from '@chakra-ui/react';
import { useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { GiftCard } from 'types/giftCard';
import { HTTP } from 'utils/http';
import { CheckoutData, CheckoutForm } from './CheckoutForm';
import FloatingLabelInput from 'components/FloatingLabelInput';

export interface GiftCardCheckoutProps {
  product: GiftCard;
}

interface GiftCardCustomizationData {
  GiftCardId: number;
  Amount: number;
  GiftMessage: string;
  Title: string;
  RecipientEmail: string;
  RecipientName: string;
}

export function GiftCardCheckout({ product }: GiftCardCheckoutProps) {
  const [activeStep, setActiveStep] = useState<0 | 1>(0);
  const {
    register,
    watch,
    formState: { isValid },
  } = useForm<GiftCardCustomizationData>({
    defaultValues: {
      GiftCardId: product.Id,
      Amount: product.SalePrice,
    },
  });

  const methods = useForm<GiftCardCustomizationData>({
    defaultValues: {
      GiftCardId: product.Id,
      Amount: product.SalePrice,
    },
  });

  async function onPurchase(Payment: CheckoutData, Test?: boolean): Promise<Record<string, unknown>> {
    const response = await HTTP.post('/sale/giftcard', { Payment, Test }).send();
    return response as Record<string, unknown>; // Return the response
  }

  const amount = watch('Amount');

  return (
    <FormProvider {...methods}>
      <Tabs index={activeStep}>
        <TabPanels>
          <TabPanel>
            <Stack as="form">
              {product.SalePrice === 0 && (
                <FormControl>
                  <FormLabel>Valeur de la carte</FormLabel>
                  <InputGroup w={100}>
                    <Input
                      sx={{
                        border: 0,
                        borderBottom: '1px solid',
                        borderRadius: 0,
                      }}
                      autoFocus
                      type="number"
                      {...register('Amount', { required: true, min: 1, max: 500, maxLength: 3, valueAsNumber: true })}
                    />
                    <InputRightElement>EUR</InputRightElement>
                  </InputGroup>

                  <FormHelperText>Saisissez une valeur comprise entre 15,00€ et 500,00€</FormHelperText>
                </FormControl>
              )}

              <FormControl>
                <FloatingLabelInput
                  marginTop={2}
                  name="Title"
                  label="Titre"
                  type="text"
                  registerOptions={{ required: 'Veuillez entrer un texte valide' }}
                  errorMessage="Veuillez entrer un texte valide"
                />
              </FormControl>

              <FormControl>
                <FormLabel>Message personnel</FormLabel>
                <Textarea {...register('GiftMessage', { required: true })} />
              </FormControl>

              <FormControl>
                <FloatingLabelInput
                  marginTop={2}
                  name="RecipientEmail"
                  label="Adresse email du bénéficiaire"
                  type="text"
                  registerOptions={{ required: 'Veuillez entrer un email valide' }}
                  errorMessage="Veuillez entrer un email valide"
                />
              </FormControl>

              <Button isDisabled={!isValid} onClick={() => setActiveStep(1)} mt={5} ml="auto">
                Procéder au paiement
              </Button>
            </Stack>
          </TabPanel>

          <TabPanel key={amount}>
            <Stack>
              <Button mr="auto" mb={5} onClick={() => setActiveStep(0)}>
                Revenir à la personnalisation de la carte cadeau
              </Button>
              <CheckoutForm amount={product.SalePrice || amount} onPurchase={onPurchase} />
            </Stack>
          </TabPanel>
        </TabPanels>
      </Tabs>
    </FormProvider>
  );
}
